export default __webpack_public_path__ + "3065eba877605a6a69e277c6f8acc656.svg";